import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import useTranslation from 'next-translate/useTranslation'
import { Nav } from 'react-bootstrap'
import dynamic from 'next/dynamic'

import FlagTeam from '@assets/images/placeholder/team-placeholder.jpg'
import { useQuery } from '@apollo/client'
import { S3_PREFIX } from '@shared/constants'
import { SERIES_FIXTURE_WIDGET } from '@graphql/series/fixtures.query'
import { convertDate, dateCheck } from '@shared/utils'
import { allRoutes } from '@shared/constants/allRoutes'
import winnerIcon from '@assets/images/icon/cup-icon.svg'

const MyImage = dynamic(() => import('@shared/components/myImage'))
const CustomLink = dynamic(() => import('@shared/components/customLink'))

const SeriesMatches = ({ id, seriesStatus }) => {
  const payload = useRef({ iSeriesId: id, nOrder: seriesStatus === 'upcoming' ? 1 : -1, sSortBy: 'dStartDate', sStatusStr: seriesStatus === 'upcoming' ? 'scheduled' : 'completed', nLimit: 5, nSkip: 1 })
  const [matches, setMatches] = useState([])
  const { t } = useTranslation()

  function handleMatchFilter(sStatusStr) {
    payload.current = { ...payload.current, sStatusStr, nOrder: sStatusStr === 'completed' ? -1 : 1 }
    refetch({ input: payload.current })
  }

  const { refetch } = useQuery(SERIES_FIXTURE_WIDGET, {
    variables: { input: payload.current },
    onCompleted: (data) => {
      setMatches(data?.fetchFixuresData || [])
    }
  })

  useEffect(() => {
    if (payload.current.iSeriesId !== id) {
      payload.current = {
        ...payload.current,
        iSeriesId: id,
        sStatusStr: seriesStatus === 'upcoming' ? 'scheduled' : 'completed',
        nOrder: seriesStatus === 'upcoming' ? 1 : -1
      }
      refetch({ input: payload.current })
    }
  }, [id])

  const itemStyle = { borderTop: '1px solid var(--light)' }
  const teamFlag = { width: 22 }
  const team = { flex: '1' }

  if (matches?.length > 0 || seriesStatus === 'live') {
    return (
      <div className="widget">
        {/* <div className="widget-title d-flex justify-content-between align-items-center">
          <h3 className="widget-title small-head mb-0 d-flex align-items-center text-uppercase justify-content-center justify-content-md-start">
            <span className="icon me-1">
              <MyImage src={rankIcon} alt="winner" width="18" height="18" />
            </span>
            <span>Asia Cup</span>
          </h3>
          <CustomLink href={allRoutes.iccRankings} prefetch={false}>
            <a className="theme-text font-semi">{t('common:VisitAll')}</a>
          </CustomLink>
        </div> */}
        <div className="light-bg br-md p-2">
          {seriesStatus === 'live' && (
            <Nav className="text-uppercase equal-width-nav mx-n1 mb-2" variant="pills">
              <Nav.Item>
                <Nav.Link className={`nav-link mx-1 ${payload.current.sStatusStr === 'completed' ? 'active' : ''}`} onClick={() => handleMatchFilter('completed')}>
                  {t('common:Recent')}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className={`nav-link mx-1 ${payload.current.sStatusStr === 'scheduled' ? 'active' : ''}`} onClick={() => handleMatchFilter('scheduled')}>
                  {t('common:Upcoming')}
                </Nav.Link>
              </Nav.Item>
            </Nav>
          )}
          {matches?.map((m, i) => {
            return (
              <div
                key={m._id}
                style={(seriesStatus === 'live' || i > 0) ? itemStyle : {}}
                className={`text-muted position-relative small-text ${(seriesStatus === 'live' || i > 0) ? 'mt-2 pt-2' : ''}`}
              >
                <CustomLink className="position-absolute w-100 h-100 start-0 top-0 opacity-0" href={payload.current.sStatusStr === 'completed' ? allRoutes.matchDetailScorecard(`/${m?.oSeo?.sSlug}/`) : allRoutes.matchDetail(m?.oSeo?.sSlug)}>
                  {m?.sTitle}
                </CustomLink>
                <div className={`d-flex align-items-center ${m?.sStatusStr === 'scheduled' ? '' : 'flex-column'}`}>
                  <div style={team} className={`d-flex align-items-center font-semi ${m?.sStatusStr === 'scheduled' ? '' : 'w-100 justify-content-between mb-1'}`}>
                    <div className="d-flex align-items-center text-dark me-2">
                      <div className={`${payload.current.sStatusStr === 'completed' ? 'd-flex align-items-center' : ''}`}>
                        <div className="rounded-circle overflow-hidden mb-01 mx-auto" style={teamFlag}>
                          <MyImage
                            src={
                              m?.oTeamScoreA?.oTeam?.oImg?.sUrl ? `${S3_PREFIX}${m?.oTeamScoreA?.oTeam?.oImg?.sUrl}` : FlagTeam
                            }
                            isLoadOnInteraction
                            alt={m?.oTeamScoreA?.oTeam?.sAbbr || m?.oTeamScoreA?.oTeam?.sTitle}
                            className="aspect-ratio"
                            width="20"
                            height="20"
                          />
                        </div>
                        <p className={`mb-0 text-center ${payload.current.sStatusStr === 'completed' ? 'ms-2' : ''}`}>{m?.oTeamScoreA?.oTeam?.sAbbr || m?.oTeamScoreA?.oTeam?.sTitle}</p>
                        {
                          m?.sStatusStr === 'completed' && m?.oWinner?._id === m?.oTeamScoreA?.oTeam?._id && (
                            <span className="ps-1" style={teamFlag}>
                              <MyImage src={winnerIcon} alt="winner" width="18" height="18" />
                            </span>
                          )}
                      </div>
                    </div>
                    {payload.current.sStatusStr === 'completed' && m?.oTeamScoreA?.sScores && (
                      <p className="mb-0">
                        <b className={`d-block ${m?.oTeamScoreA?.oTeam?._id === m?.oWinner?._id ? 'theme-txt' : ''}`}>
                          {m?.oTeamScoreA?.sScores} ({m?.oTeamScoreA?.sOvers} {t('common:Ov')})
                        </b>
                      </p>
                    )}
                  </div>
                  {payload.current.sStatusStr === 'scheduled' && (
                    <p className="mb-0 text-center mx-2">
                      <>
                        {m?.sSubtitle}
                        <br />
                        {convertDate(dateCheck(m?.dStartDate))}
                      </>
                    </p>
                  )}
                  <div style={team} className={`d-flex align-items-center font-semi justify-content-end ${m?.sStatusStr === 'scheduled' ? '' : 'w-100 justify-content-between'} ${m?.sStatusStr !== 'scheduled' && m?.oTeamScoreB?.sScores ? 'flex-row-reverse' : ''}`}>
                    {payload.current.sStatusStr === 'completed' && m?.oTeamScoreB?.sScores && (
                      <p className="mb-0">
                        <b className={`d-block ${m?.oTeamScoreB?.oTeam?._id === m?.oWinner?._id ? 'theme-txt' : ''}`}>
                          {m?.oTeamScoreB?.sScores} ({m?.oTeamScoreB?.sOvers} {t('common:Ov')})
                        </b>
                      </p>
                    )}
                    <div className={`d-flex align-items-center text-dark ${payload.current.sStatusStr === 'scheduled' ? 'ms-2' : ''}`}>
                      <div className={`${payload.current.sStatusStr === 'completed' ? 'd-flex align-items-center' : ''}`}>
                        <div className="rounded-circle overflow-hidden mb-01 mx-auto" style={teamFlag}>
                          <MyImage
                            src={
                              m?.oTeamScoreB?.oTeam?.oImg?.sUrl ? `${S3_PREFIX}${m?.oTeamScoreB?.oTeam?.oImg?.sUrl}` : FlagTeam
                            }
                            isLoadOnInteraction
                            className="aspect-ratio"
                            alt={m?.oTeamScoreB?.oTeam?.sAbbr || m?.oTeamScoreB?.oTeam?.sTitle}
                            width="20"
                            height="20"
                          />
                        </div>
                        <p className={`mb-0 text-center ${payload.current.sStatusStr === 'completed' ? 'ms-2' : ''}`}>{m?.oTeamScoreB?.oTeam?.sAbbr || m?.oTeamScoreB?.oTeam?.sTitle}</p>
                        {
                          m?.sStatusStr === 'completed' && m?.oWinner?._id === m?.oTeamScoreB?.oTeam?._id && (
                            <span className="ps-1" style={teamFlag}>
                              <MyImage src={winnerIcon} alt="winner" width="18" height="18" />
                            </span>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
                {payload.current.sStatusStr === 'completed' && (m?.sStatusNote || m?.sResult) && (
                  <p
                    className={`${m?.sStatusStr === 'completed' ? 'text-success' : 'text-danger'} overflow-hidden text-nowrap t-ellipsis font-medium mt-1 mb-0`}
                  >
                    <span className='text-muted'>{m?.sSubtitle}:</span> {m?.sResult || m?.sStatusNote}
                  </p>
                )}
              </div>
            )
          })}
          {matches?.length === 0 && (
            <h5 className='text-center mb-0 mt-3'>{t('common:NoDataFound')}</h5>
          )}
        </div>
      </div>
    )
  } else return null
}

SeriesMatches.propTypes = {
  id: PropTypes.string.isRequired,
  seriesStatus: PropTypes.string.isRequired
}
export default SeriesMatches
